import styled from 'styled-components';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  FormItem,
  FormLabel,
} from 'components';

export const ContentSection = styled.section.attrs({
  className: 'mx-auto w-full max-w-6xl flex flex-col gap-3 px-3 pt-3 pb-20 bg-background',
})``;

export const StyledCard = styled(Card).attrs({
  className: 'rounded-md border border-border shadow-sm gap-2 py-0',
})``;

export const StyledCardHeader = styled(CardHeader).attrs({
  className: 'px-4 py-3 gap-1',
})``;

export const StyledCardTitle = styled(CardTitle).attrs({
  className: 'text-base font-semibold leading-6',
})``;

export const StyledCardDescription = styled(CardDescription).attrs({
  className: 'text-sm leading-4',
})``;

export const StyledCardContent = styled(CardContent).attrs({
  className: 'px-4 pb-4 pt-0',
})``;

export const StyledForm = styled.form.attrs({
  className: 'flex flex-col gap-6',
})``;

export const StyledFormItem = styled(FormItem).attrs({
  className: 'flex flex-col gap-1',
})``;

export const StyledFormLabel = styled(FormLabel).attrs({
  className: 'text-sm font-semibold leading-4',
})``;

export const ButtonContainer = styled.div.attrs({
  className: 'flex',
})``;
